module.exports = __webpack_public_path__ + "static/media/AvenirNext-DemiBoldItalic.633e53d0.woff2";